<div aria-hidden="true" [style.textAlign]="!!ref.innerHTML.trim() ? 'center' : undefined">
    <svg class="logo-loading" viewBox="0 0 100 100" width="100%" height="100%">
        <g class="logo-loading__container">
            <circle
                class="logo-loading__container__circle"
                r="48"
                cx="50"
                cy="50"
                [style.stroke]="color"
            />
        </g>
        <rect
            class="logo-loading__rect logo-loading__rect--up"
            width="9"
            height="46"
            x="27"
            y="50"
            shape-rendering="crispEdges"
            [style.stroke]="color"
        ></rect>
        <rect
            class="logo-loading__rect logo-loading__rect--down"
            width="9"
            height="46"
            x="36"
            y="7"
            shape-rendering="crispEdges"
            [style.stroke]="color"
        ></rect>
        <rect
            class="logo-loading__rect logo-loading__rect--up"
            width="9"
            height="46"
            x="45"
            y="50"
            shape-rendering="crispEdges"
            [style.stroke]="color"
        ></rect>
        <rect
            class="logo-loading__rect logo-loading__rect--down"
            width="9"
            height="46"
            x="54"
            y="7"
            shape-rendering="crispEdges"
            [style.stroke]="color"
        ></rect>
        <rect
            class="logo-loading__rect logo-loading__rect--up"
            width="9"
            height="46"
            x="63"
            y="50"
            shape-rendering="crispEdges"
            [style.stroke]="color"
        ></rect>
    </svg>
    <span #ref><ng-content></ng-content></span>
</div>
